import React, {useEffect} from 'react';
import {Button, Container, Grid, Paper, Typography} from "@mui/material";
import {lightBlue} from "@mui/material/colors";
import {styled} from "@mui/material/styles";
import {useDispatch, useSelector} from "react-redux";
import {
    replaceLatestTempIdWithRealId,
    setDealerActivities,
    setExtraActivities,
    setTransactionClient
} from "../../../redux/actions/transactionActions";
import {
    getMaxPaxFromExtras,
    getNextStep,
    getPreviousStep, getStepFromUrl,
} from "../../../utils/utils";
import {useHistory} from "react-router-dom";
import AvailabilityCalendar from "./AvailabilityCalendar";
import ActivityOverview from "./ActivityOverview";
import Itinerary from "./Itinerary";
import Summary from "./Summary";
import DayTripStepper from "./DayTripStepper";
import {setStep} from "../../../redux/actions/stepActions";

const PREFIX = 'ActivityCard';
const classes = {
    root: `${PREFIX}-root`,
    container: `${PREFIX}-container`,
    tripImage: `${PREFIX}-trip-image`,
    status: `${PREFIX}-status`,
    hold: `${PREFIX}-hold`,
    waiting: `${PREFIX}-waiting`,
    paid: `${PREFIX}-paid`,
    tripTitle: `${PREFIX}-tripTitle`,
    tripDetailsContainer: `${PREFIX}-tripDetailsContainer`,
    tripDetails: `${PREFIX}-tripDetails`,
    footerInfo: `${PREFIX}-footerInfo`,
}
const PaperTrip = styled(Paper)(({theme}) => ({
    [`&.${classes.root}`]: {
        maxWidth: '900px',
        margin:'auto',
        padding: '20px',
    },
    [`& .${classes.status}`]: {
        color: 'white',
        padding: '5px',
        textTransform: 'uppercase',
        fontWeight: '600',
        fontSize: '1.4rem',
        letterSpacing: '1.2px',
    },
    [`& .${classes.container}`]: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
    },
    [`& .${classes.tripImage}`]: {
        objectFit: 'cover',
        height: '100%',
    }, [`& .${classes.hold}`]: {
        backgroundColor: 'lightgray',
    },
    [`& .${classes.waiting}`]: {
        backgroundColor: theme.palette.warning.main,
    },
    [`& .${classes.paid}`]: {
        backgroundColor: theme.palette.success.main,
    },
    [`& .${classes.tripTitle}`]: {
        fontSize: '2.4rem',
        letterSpacing: '1.2px'
    },
    [`& .${classes.tripDetailsContainer}`]: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    [`& .${classes.tripDetails}`]: {
        fontSize: '1.2rem',
        marginLeft: '5px'
    },
    [`& .${classes.footerInfo}`]: {
        fontWeight: '600'
    }
}))
const ActivityCardView = ({activity, pickDate, addOrRemove, history}) => {
    const {extra} = useSelector(state => state.transactions);
    const dispatch = useDispatch();
    const historyUrl = useHistory();
    const step = useSelector(state => state.step);
    const prevStep = getPreviousStep(step);
    const currentValue = extra[activity.id] || '';
    const prefixUrl = 'booking/day-trips';

    const maxPaxAllowed = getMaxPaxFromExtras(extra,true) || 200;
    const fixPax = getMaxPaxFromExtras(extra) ;

    useEffect(() => {
        const stepNum = getStepFromUrl(history.location.pathname);
        dispatch(setStep(stepNum));
    }, []);

    useEffect(() => {
        if (activity?.id) {
            sessionStorage.setItem('lastActivityId', activity.id);
        }
    }, [activity?.id]);


    const handlerActivity = (availability) => {
        dispatch(setDealerActivities(
            activity.company,
            activity.id,
            availability.id,
            availability,
            true
        ));
    };
    const removeActivity = (availability)=>{
        dispatch(setDealerActivities(
            activity.company,
            activity.id,
            availability.id,
            null,
            false
        ));
    };



    const goBack = () => {
        historyUrl.push(`/${prefixUrl}${prevStep.url}`);
    };

    const goToNextStep = () => {
        const nextStep = getNextStep(step);
        historyUrl.push(`/${prefixUrl}${nextStep.url}`);
    };

    const goToInquiry = (date) => {
        historyUrl.push(`/${prefixUrl}/${activity.id}/inquiry?date=`+date);
    };

    return (

        <div style={{marginBottom:'20px'}}>
            <Container maxWidth="lg" className={'tripInfoDetails'}>
                <DayTripStepper/>
                <div style={{marginTop: 50}}/>
                <Grid container>
                    <Grid item sm={12} md={9} xs={12}>
                        <PaperTrip className={classes.root} elevation={3} sx={{mx: {xs: '1.6rem', lg: '0'}}}>
                        <Typography variant="h2" component="h2" className={'tripTitle'}>
                            {activity['name']}
                        </Typography>
                        <div dangerouslySetInnerHTML={{__html: activity['description']}}/>
                        <Typography variant="h4" align="left" style={{padding: '10px 12px 10px'}}>
                            <strong>
                                Pricing: US <span style={{color: lightBlue[500]}}>${`${parseFloat(activity['price']).formatMoney(0)}`}</span>
                                /Retail (+ applicable taxes)
                            </strong>
                        </Typography>
                        {pickDate === 1 && <AvailabilityCalendar fixPax={fixPax} removeActivity={removeActivity} activity={activity} handlerActivity={handlerActivity} inquiryAction={goToInquiry} maxPax={maxPaxAllowed}/>}
                        </PaperTrip>
                    </Grid>
                    <Grid item sm={12} md={3} xs={12}>
                        <Paper style={{marginBottom: 10}}>
                            <Button color={'primary'} variant={'contained'} fullWidth onClick={goToNextStep}>
                                Next Step
                            </Button>
                            <Button color={'secondary'} variant={'contained'} fullWidth onClick={goBack}>
                                Add Another Activity
                            </Button>
                        </Paper>
                        <ActivityOverview activity={activity}/>
                        <Itinerary removable={true}/>
                        <Summary />
                    </Grid>
                </Grid>
            </Container>
        </div>
    );
};

export default ActivityCardView;